export const AcceptInviteForm = 'ACCEPT_INVITE_FORM'
